import { useAppInfiniteQuery } from "@/hooks/useAppInfiniteQuery"
import { type GetClustersParams, getClusters, getGetClustersQueryKey } from "@/networking/api"
import { STALE_TIME_FIVE_MINUTES_IN_MS } from "@/utils/constants"

export const useGetClusterInfiniteQuery = (
  params: GetClustersParams,
  options?: { enabled?: boolean }
) => {
  const {
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    flatData: clusters,
    totalCount: count,
  } = useAppInfiniteQuery(getClusters, getGetClustersQueryKey, params, {
    staleTime: STALE_TIME_FIVE_MINUTES_IN_MS,
    ...options,
  })

  const isFetchingData = isLoading || isFetchingNextPage

  return { clusters, fetchNextPage, hasNextPage, isFetchingData, count }
}

export const useGetClustersFirstPageQuery = (params: GetClustersParams) => {
  const modifiedParams = {
    ...params,
    page: 1,
    itemsPerPage: 20,
  }

  const {
    isLoading: isLoadingItems,
    isFetching: isFetchingItems,
    flatData: clusters,
    totalCount: count,
  } = useAppInfiniteQuery(getClusters, getGetClustersQueryKey, modifiedParams, {
    staleTime: STALE_TIME_FIVE_MINUTES_IN_MS,
  })

  const isLoading = isLoadingItems || isFetchingItems

  return { clusters, isLoading, count }
}
